<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid ">
    <div class="row m-t-md">
      <div class="col-12">
        <p-panel *ngIf="(activeLicense && activeLicense.active && activeLicense.valid); else noActiveLicense">
          <p-header>
            <!-- <span>
         <i class="fa fa-file" aria-hidden="true"></i> Auditoria</span> -->
            <span class="leyenda float-right">{{ 'License.active' | translate }}</span>
          </p-header>
          <dl class="row">
            <dt class="col-12 col-md-12">
              <div class="no-padding-left m-b-xs text-ellipsis ng-star-inserted">
                <div class="alert alert-info m-b-xs text-ellipsis col-12"><span><i aria-hidden="true"
                      class="fas fa-1-5x fa-info-circle m-r-md"></i> {{'License.valuesLicense' | translate}} </span>
                </div>
              </div>
            </dt>
            <dt class="col-12 col-md-6">{{ 'License.hostNameActive' | translate }}:</dt>
            <dd class="col-12 col-md-6"> {{activeLicense.hostNameActive}} </dd>
            <dt class="col-12 col-md-6">{{ 'License.typeLicense' | translate }}:</dt>
            <dd class="col-12 col-md-6"> {{activeLicense.typeLicense}} </dd>
            <dt class="col-12 col-md-6"> {{ 'License.nameApplication' | translate }}:</dt>
            <dd class="col-12 col-md-6"> {{activeLicense.nameApplication}}</dd>
            <dt class="col-12 col-md-6"> {{ 'License.numUsersMax' | translate }}:</dt>
            <dd class="col-12 col-md-6"> {{activeLicense.numUsers}}</dd>
            <dt class="col-12 col-md-6"> {{ 'License.numGuestUsersMax' | translate }}:</dt>
            <dd class="col-12 col-md-6"> {{activeLicense.numGuestUser}}</dd>
            <dt class=" col-12 col-md-6"> {{ 'License.expired' | translate }}:</dt>
            <dd class="col-12 col-md-6"> {{activeLicense.dateExpiredString}}</dd>
            <dt class="col-12 col-md-12 m-t-md">
              <div class="no-padding-left m-b-xs text-ellipsis ng-star-inserted">
                <div class="alert alert-info m-b-xs text-ellipsis col-12"><span><i aria-hidden="true"
                      class="fas fa-1-5x fa-info-circle m-r-md"></i> {{'License.stateLicense' | translate}} </span>
                </div>
              </div>
            </dt>
            <dt class=" col-12 col-md-6"> {{ 'License.moreUsersAllowed' | translate }}:</dt>
            <dd *ngIf="activeLicense.moreUsersAllowed" class="col-12 col-md-6"><span class="text-success">
                <i class="fas fa-check" aria-hidden="true"></i>
              </span></dd>
            <dd *ngIf="!activeLicense.moreUsersAllowed" class="col-12 col-md-6">
              <span class="text-danger">
                <i class="fas fa-times" aria-hidden="true"></i>
              </span>
            </dd>
            <dt class=" col-12 col-md-6">{{ 'License.numUsers' | translate }}:</dt>
            <dd class="col-12 col-md-6">{{activeLicense.numusersActiv}}</dd>
            <dt class=" col-12 col-md-6">{{ 'License.numGuestUsers' | translate }}:</dt>
            <dd class="col-12 col-md-6">{{activeLicense.numGuestUsersActiv}}</dd>
          </dl>
          <div class="btn-group d-flex justify-content-end text-right">
            <div class="btn-group-xs">
              <button class="m-l-sm btn btn-danger btn-sm" appNoDblClick (click)="remove(activeLicense)" type="button">
                <i class="fas fa-times"></i> {{ 'License.delete' | translate }}</button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md" *ngIf="licensesNoActive && licensesNoActive.length > 0">
      <div class="col-12">
        <!-- zona de datos -->
        <p-panel>
          <p-header>
            <!-- <span>
         <i class="fa fa-file" aria-hidden="true"></i> Auditoria</span> -->
            <span class="leyenda float-right">{{ 'License.inactives' | translate }}</span>
          </p-header>
          <p-table [value]="licensesNoActive" sortOrder="1" [paginator]="false" class="footer-over-pagination">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="7"> No se han encontrado licencias </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="hostNameActive" styleClass="text-left col-2">{{ 'License.hostNameActive' |
                  translate }} <p-sortIcon field="hostNameActive"></p-sortIcon>
                </th>
                <th pSortableColumn="typeLicense" styleClass="text-left col-2">{{ 'License.typeLicense' | translate }}
                  <p-sortIcon field="typeLicense"></p-sortIcon>
                </th>
                <th pSortableColumn="numUsers" styleClass="text-left col-2">{{ 'License.numUsersMax' | translate }}
                  <p-sortIcon field="numUsers"></p-sortIcon>
                </th>
                <th pSortableColumn="numGuestUser" *ngIf="licensesNoActive && licensesNoActive.length > 0"
                  styleClass="text-left col-2">{{ 'License.numGuestUsersMax' | translate }} <p-sortIcon
                    field="numGuestUser"></p-sortIcon>
                </th>
                <th pSortableColumn="dateExpiredString" styleClass="text-left col-2">{{ 'License.expired' | translate }}
                  <p-sortIcon field="dateExpiredString"></p-sortIcon>
                </th>
                <th styleClass="text-right action-column">{{ 'License.valid' | translate }}</th>
                <th styleClass="text-right action-column"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-license>
              <tr>
                <td field="hostNameActive">{{license.hostNameActive}}</td>
                <td field="typeLicense">{{license.typeLicense}}</td>
                <td field="numUsers">{{license.numUsers}}</td>
                <td *ngIf="licensesNoActive && licensesNoActive.length > 0" field="numGuestUser">
                  {{license.numGuestUser}} </td>
                <td field="dateExpiredString">{{license.dateExpiredString}}</td>
                <td>
                  <span class="text-danger" *ngIf="!license.valid">
                    <i class="fas fa-times" aria-hidden="true"></i>
                  </span>
                  <span class="text-success" *ngIf="license.valid">
                    <i class="fas fa-check" aria-hidden="true"></i>
                  </span>
                </td>
                <td>
                  <button class="btn btn-xs btn-danger " aria-expanded="false" (click)="remove(license)" type="button">
                    <i class="fas fa-times" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
  <ng-template #noActiveLicense>
    <div class="alert alert-danger m-b-xs text-ellipsis col-12" role="alert">
      <span>
        <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{'License.noLicense' | translate
        }}</span>
      <dl class="row">
        <dt class="col-12 col-md-6"></dt>
      </dl>
      <dl class="row">
        <dt class="col-12 col-md-6">{{ 'License.hostrequerido' | translate }}: {{hostNameActive}}</dt>
      </dl>
      <dl class="row">
        <dt class="col-12 col-md-6">{{ 'License.numUsers' | translate }}: {{numUsersActive}}</dt>
      </dl>
      <dl class="row">
        <dt class="col-12 col-md-6">{{ 'License.numGuestUsers' | translate }}: {{numInvitsAllowed}}</dt>
      </dl>
    </div>
  </ng-template>
</div>